let contact_name = null;
let contact_email = null;
let contact_company = null;
let contact_mobile = null;
let contact_business = null;
let contact_message = null;
let contact_country = null;
let contact_designation = null;
let isValid = false;
let issubmitted = false;
function showError(id) {
  const input = document.getElementById(id);
  input.classList.add("error");
}
function clearError(id) {
  const input = document.getElementById(id);
  input.classList.remove("error");
}
function attachInputListeners() {
  ["contact_name", "contact_email"].forEach((id) => {
    const input = document.getElementById(id);
    input.addEventListener("input", () => clearError(id));
  });
}

function showThankYou() {
  const form = document.getElementById("contactForm");
  const thankyou = document.querySelector(".thankyou");

  if (form) form.classList.add("is-hidden");
  if (thankyou) {
    thankyou.classList.add("is-visible");
    thankyou.setAttribute("aria-hidden", "false");
  }
}

function activateEnquiry(contactFrom) {
  attachInputListeners();

  document.querySelector(".button-container").addEventListener("click", (e) => {
    e.preventDefault();
    isValid = true;

    contact_name = document.getElementById("contact_name").value.trim();
    contact_email = document.getElementById("contact_email").value.trim();
    contact_company = document.getElementById("contact_company").value.trim();
    contact_mobile = document.getElementById("contact_mobile").value.trim();
    contact_business = document.getElementById("contact_business").value.trim();
    contact_message = document.getElementById("contact_message").value.trim();
    contact_country = document.getElementById("contact_country").value.trim();
    contact_designation = document
      .getElementById("contact_designation")
      .value.trim();

    ["contact_name", "contact_email"].forEach(clearError);

    // Validation
    if (!contact_name) {
      showError("contact_name");
      isValid = false;
    }

    if (!contact_email) {
      showError("contact_email");
      isValid = false;
    } else {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
      if (!re.test(contact_email)) {
        showError("contact_email");
        isValid = false;
      } else {
        clearError("contact_email"); // ✅ THIS FIXES IT
      }
    }

    if (!isValid) return false;
    if (issubmitted) return;
    issubmitted = true;

    // Collect data
    const form = document.getElementById("contactForm");
    const formData = new FormData(form);

    const data = [];
    formData.forEach((value, key) => {
      data.push({ name: key, value: value });
    });

    // console.log(data);

    data.push({ name: "contact_from", value: contactFrom });

    fetch("https://www.alivenow.in/getintouch_snamgroup.php", {
      method: "POST",
      body: new URLSearchParams(
        data.reduce((acc, cur) => {
          acc[cur.name] = cur.value;
          return acc;
        }, {}),
      ),
    })
      .then(() => {
        showThankYou();
        issubmitted = true;
      })
      .catch(() => showThankYou());
  });
}

export { activateEnquiry };
